export function variantUrl(value, variantId, optionIds = '', base = 'https://example.invalid') {
  const url = new URL(value, base);
  url.searchParams.delete('variant');
  url.searchParams.delete('option_values');
  if (variantId) url.searchParams.set('variant', String(variantId));
  else if (optionIds) url.searchParams.set('option_values', optionIds);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function canPurchase(state, sellingPlanId = '') {
  return Boolean(state?.id && state.available && (!state.requiresSellingPlan || sellingPlanId));
}

export function nextQuantity(current, delta) {
  return Math.max(1, (Number.isFinite(Number(current)) ? Math.floor(Number(current)) : 1) + delta);
}

export function cartAjaxUrl(action) {
  const url = new URL(action);
  url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
  return url.href;
}

if (typeof document !== 'undefined' && document.querySelector('[data-product-page]')) import('./product-controller.js');
